import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { intakeNormalize } from "@/lib/intakeNormalize";
import { HttpResponse, JobIntakeWithCompletion } from "@/types";

export function useGetJobIntake() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-intake", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-intake`;
      const res = await guacHttpClient.get<
        JobIntakeWithCompletion,
        HttpResponse<JobIntakeWithCompletion>
      >(path);
      return { ...res.data, jobIntake: intakeNormalize.job(res.data.jobIntake) };
    },
  });
}
